import React from 'react';
import styled from '@emotion/styled';
import { ILandingPageProps } from '../../interfaces/IPages';
import { IShip } from '../../interfaces/ship/IShip';
import { SectionHeadline } from '../components/atoms/section-headline/section-headline';
import { StyledSectionHeadlineWrapper } from '../components/sections/horizontal-content-module/horizontal-content-module.style';
import { mediaQueries } from '../style/global-style';
import { __ } from '../utils/translation-service';

const SeoWrapper = styled.div`
    max-width: 1170px;
    padding: 20px 30px 30px;
    margin: 0 auto;
    margin-bottom: 20px;
    color: ${(props) => props.theme.shades.blackGrey};
    padding: 20px 15px;
    font-size: 15px;
    background-color: ${(props) => props.theme.shades.white};

    @media ${mediaQueries.tabletAndUp} {
        padding: 45px 20px;
    }
    @media ${mediaQueries.desktopAndUp} {
        padding: 45px 50px;
    }

    h2 {
        margin: 40px 0 15px;
        text-align: center;
        font-weight: bolder;
        font-size: 25px;
    }

    p {
        margin: 10px 0;
    }
`;

export const ShipAmenitiesMod = ({
    getLandingPage,
    modulesData,
}: ILandingPageProps['pageProps']) => {
    if (!modulesData) {
        return null;
    }
    const shipData = modulesData[`ship${getLandingPage.id}`] as IShip;

    if (!shipData?.seoTextBottom) {
        return null;
    }

    return (
        <div>
            <StyledSectionHeadlineWrapper>
                <SectionHeadline firstChunk={shipData.title} secondChunk={__('amenities')} />
            </StyledSectionHeadlineWrapper>
            <SeoWrapper dangerouslySetInnerHTML={{ __html: shipData.seoTextBottom }} />
        </div>
    );
};
